export default __webpack_public_path__ + "static/media/logo512.6adb676e.png";